import { assoc, compose, path, reduce } from 'ramda'
import { mapActions } from 'vuex'

const navMenuMixin = {
  data() {
    return {
      routes: ['Dashboard', 'ImportBasket', 'Offers', 'Basket', 'Orders'],
      routeLabels: { Dashboard: 'Dashboard', ImportBasket: 'Import Basket', Offers: 'Offers', Basket: 'Basket', Orders: 'Orders' },
      routeIcons: { Dashboard: 'dashboard', ImportBasket: 'upload', Offers: 'label', Basket: 'bag', Orders: 'box' },
    }
  },
  computed: {
    currentRoute() {
      return path(['$route', 'name'], this)
    },
    routePaths() {
      return compose(
        reduce((carry, item) => assoc(item.name, item.path, carry), {}),
        path(['$router', 'options', 'routes']),
      )(this)
    },
  },
  methods: {
    ...mapActions(
      {
        logout: 'auth/logout',
      },
    ),
    getRoutePath(routeName) {
      const route = this.$router.options.routes.find(({ name }) => name === routeName)
      return path(['path'], route)
    },
    isCurrentRoute(routeName) {
      return routeName === this.currentRoute ||
        routeName.substr(0, routeName.length - 1) === this.currentRoute ||
        (routeName === 'Basket' && this.currentRoute === 'BasketSubmitted')
    },
  },
}

export default navMenuMixin
